import React from 'react';
import { Field } from 'react-final-form';
import classnames from 'classnames';

interface CheckboxFieldProps {
  validate?: (value: any) => string | undefined;
  name: string;
  form: any;
  text?: string;
  initial?: boolean;
}

class CheckboxField extends React.Component<CheckboxFieldProps> {
  render() {
    const { validate, name, form, text, initial } = this.props;

    return (
      <Field
        initialValue={initial}
        validate={validate}
        name={name}
        render={({ input }) => (
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => form.change(input.name, !input.value)}
          >
            <i
              className={classnames(
                'fab',
                {
                  'far fa-square': !input.value
                },
                {
                  'fas fa-check-square': input.value
                }
              )}
              data-cy="checkbox-field"
            />
            {text && (
              <span className="text" style={{ marginLeft: '5px' }}>
                {text}
              </span>
            )}
          </div>
        )}
      />
    );
  }
}

export default CheckboxField;
